<div class="flex flex-col min-h-screen">
  <header class="flex-shrink-0 overflow-visible min-h-[5rem]">
    <app-header></app-header>
  </header>
  <div class="flex-1 min-h-0 flex flex-col overflow-hidden bg-[#2a3a6c] min-h-[calc(100vh-8rem)]">
    <main class="flex-1 min-h-0 flex flex-col overflow-y-auto overflow-x-hidden py-2.5 px-4 md:px-6 min-h-[calc(100vh-8rem)]">
      <router-outlet></router-outlet>
    </main>
  </div>
  <footer class="flex-shrink-0 min-h-[3rem] bg-gray-200">
    <app-footer></app-footer>
  </footer>
</div>
